module.exports = __webpack_public_path__ + "static/media/Lineup_Mobile_BackgroundPic.45590aaa.jpg";